<div class="row">
  <div class="col-md-12">
    <div class="clear-spacing" *ngIf="billingType === 'TIMETAP'"></div>
    <div class="portlet box grey" [ngClass]="{'remove-margin-bottom': billingType === 'RECURLY'}">
      <div *ngIf="business.status==='SUSPENDED'">
        <div class="alert alert-danger text-center" style="margin-bottom: 0px;">
          Your account has been suspended due to non-payment. Please enter your billing information
          below.<br /><br />
          Once you've updated your billing, please click the reload button below to reactivate your
          account.<br /><br />
          <button class="btn blue" (click)="reloadBusinessToReactivate()"
                  [disabled]="reloadingBusiness"><span
            *ngIf="!reloadingBusiness">Reload & Reactivate</span><span *ngIf="reloadingBusiness"><i
            class="fa fa-spinner fa-spin fa-fw"></i>Reloading...</span></button>
          <br /><br />
          <span *ngIf="businessCouldNotBeReactivated"><i class="fa fa-warning"></i> We could not validate reactivating your business. You can try clicking the button above again but if you continue to experience issues please reach out to our support team by clicking the chat icon in the bottom right</span>
        </div>
      </div>

      <div *ngIf="business.status==='HIBERNATE'">
        <div class="alert alert-info text-center" style="margin-bottom: 0px;">
          Your account is currently in hibernation. Please check your billing information below. If it
          is up to date and you are ready to reactivate your account, simply click the reactivate
          button below. Otherwise, please first update your billing and then press
          reactivate.<br /><br />
          <button class="btn btn-primary" (click)="awakeFromHibernate()"
                  [disabled]="reactivating"><span
            *ngIf="!reactivating">Reactivate</span><span *ngIf="reactivating"><i
            class="fa fa-spinner fa-spin fa-fw"></i>Reactivating...</span></button>
          <br /><br />
        </div>
      </div>
      <div class="portlet-body" *ngIf="billingType === 'RECURLY'" style="padding: 15px;">
        <div class="row" id="recurlyBilling" style="text-align: center;">
          <div class="col-md-12">
            <div class="form-group">
              <label>Please visit your secure billing information page to update your billing:</label>
            </div>
          </div>
        </div>
        <div class="row" id="recurlyBillingBtn" style="text-align: center;">
          <div class="col-md-12">
            <div class="form-group">
              <a href="{{billingUrl}}" target="_blank" class="btn default"><i
                class="fa fa-credit-card"></i> View Billing Information</a>
            </div>
          </div>

        </div>
      </div>
      <div class="portlet-body" *ngIf="billingType === 'TIMETAP'">

      </div>
    </div>

  </div>
</div>
